//Angular
import { Component, OnInit, SimpleChange, ViewChild, ViewEncapsulation } from "@angular/core";
import { FormArray, FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";
import { Router  } from '@angular/router';

//Models
import { Period } from "src/app/models/Period";
import { Answer, AnswerRange } from "src/app/models/Answer";
import { Question } from 'src/app/models/Question';

//dependecies
import { ToastrService } from "ngx-toastr";
import { CloudData, CloudOptions } from 'angular-tag-cloud-module';

//Store
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";

//States
import { SidebarState } from "../../../../stores/sidebar/sidebar.reducer";
import { SurveyState } from '../../../../stores/survey/survey.reducer';

//services
import { DashboardService } from '../../../../services/dashboard/dashboard.service';
import { LoaderService } from '../../../../services/loader/loader.service';

//Utils
import  Utils  from 'src/app/utils/utils';
import  Formatter  from 'src/app/utils/formatters';

//request
import { AnswerEmotionRequest, FilteredAiRequest, OpenTextBoxesRequest } from "src/app/models/global.request";

//Htmlto image
import * as htmlToImage from 'html-to-image';
import { EChartsOption } from "echarts";

@Component({
  selector: "app-dash-text-boxes",
  templateUrl: "./dash-text-boxes.component.html",
  styleUrls: ["./dash-text-boxes.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class DashboardTextBoxesComponent  implements OnInit {

  questions: any;
  touchpointsGroupped: any;
  showModalKeys: boolean = false;

  showAccordionCloud: boolean = false;
  cloudOptions: CloudOptions = {
    width: 1,
    height: 350,
    overflow: false,
  };
  cloudData: CloudData[] = [];

  textAreaQuestions: any;

  sidebarState$: Observable<SidebarState>;
  surveyState$ : Observable<SurveyState>;
  utils!:Utils;
  formatter!:Formatter;

  dashboardData$: Observable<any[]> | undefined;
  answersOptions !: AnswerRange[];
  filteredQuestionType = "";

  //Local Variables
  periodList!: Period[] | null;
  periodOneStartDate!: Date;
  periodOneEndDate!: Date;
  periodTwoStartDate!: Date;
  periodTwoEndDate!: Date;
  isOnePeriod = false;

  surveyName!: string;
  filterQuestions: any ;

  filterNPSValues = [
    {value:"detractors", label:"Detractors"},
    {value:"passives", label:"Passives"},
    {value:"promoters", label:"Promoters"},
  ]
  filterAggregationValues !: any;

  periodsCounters : any;
  currentSurvey: any ;
  openTextBoxesAnswers$!: any;

  npsAnswers: any;
 //Toggle
  showOptionsContainer !: boolean;
  showFiltersListFormVisible: boolean = true;
  selectedCrossQuestion!: Question;
  currentPeriodToggle!: number;

  //Pagination
  startPage : Number;
  paginationLimit:Number;

  showMore = false;

  // AI
  chartEmotionsOption!: EChartsOption;
  showEmotionsSummary: boolean = false;
  showRefreshAiModal: boolean = false;
  showAiRecap: boolean = false;
  showAccordionFindings: boolean = false;
  aiSelectedQuestion = new FormControl('');
  aiRecaps: any = [];
  aiThematics: any = [];
  emotionColors: any = {
    gioia: "#f4eb24",
    fiducia: "#cfdd26",
    paura: "#a3cc3f",
    sorpresa: "#61c086",
    tristezza: "#40bded",
    disgusto: "#964097",
    rabbia: "#dd0c81",
    aspettativa: "#faa719",
    indefinibile: "#787A75",
  };
  emotionsMapping: any = {
    gioia: 'Joy',
    fiducia: 'Trust',
    paura: 'Fear',
    sorpresa: 'Surprise',
    tristezza: 'Sadness',
    disgusto: 'Disgust',
    rabbia: 'Anger',
    aspettativa: 'Expectation',
    indefinibile: 'Undefinable',
    non_risposta: 'No-answer',
  };
  emotions: string[] = ['gioia', 'fiducia', 'paura', 'sorpresa', 'tristezza', 'disgusto', 'rabbia', 'aspettativa', 'indefinibile'];
  emotionsSummary: any[] = [];
  emotionsTotalCount: number = 0;
  editQuestionEmotion = this.fb.group({
    event_id: [0, [Validators.required]],
    emotion: ["", [Validators.required]],
  });
  showFilterEmotions: boolean = false;
  showFilterConfidence: boolean = false;
  filteredEmotion = new FormControl('');
  filteredConfidence = this.fb.group({
    min: [0, [Validators.min(0), Validators.max(100)]],
    max: [100, [Validators.min(0), Validators.max(100)]],
  });
  hasReloadedAi: boolean = false;
  toneMapping: any = {
    positivo: 'Monitor',
    negativo: 'Act',
    neutro: 'Review',
    misto: "Review",
  };

  //Constructor
  constructor(
    private store: Store<{ sidebarState: SidebarState, surveyState: SurveyState  }>,
    public fb: FormBuilder,
    private dashboardService: DashboardService,
    private toastr: ToastrService,
    private router: Router,
    private loaderService: LoaderService,
  ) {
    this.sidebarState$ = store.select("sidebarState");
    this.surveyState$ = store.select('surveyState');
    this.utils = new Utils();
    this.formatter = new Formatter();
    this.startPage = 0;
    this.paginationLimit = 10;
    this.currentPeriodToggle = 0;
  }


  filterOpenTextBoxesForm = this.fb.group({
    filterQuestionValue:  [ "", [Validators.required]],
    filterQuestionType:  [ "", [Validators.required]],
    filterQuestionId: [null as string | null, [Validators.required]],
    filterAnswerValue: ["", [Validators.required]],
    filterAnswerRangeStart: ["", [Validators.required]],
    filterAnswerRangeEnd: ["", [Validators.required]],
    filterCrossQuestionValue: ["",[Validators.required]],
    filterNPSValue:[null as string | null,[Validators.required]],
    filterSelectedPeriodValue:["",[Validators.required]],
    filterAggregationValue:[null as string | null,[Validators.required]],
    selectedFiltersListForm: this.fb.array([],) ,
  });

  setfilterQuestionValue(value: any) {
    this.filterQuestionValue?.setValue(value, {
      onlySelf: true,
    });
  }
  setfilterQuestionId(value: any) {
    this.filterQuestionId?.setValue(value, {
      onlySelf: true,
    });
  }
  setfilterQuestionType(value: any) {
    this.filterQuestionType?.setValue(value, {
      onlySelf: true,
    });
  }
  setfilterCrossQuestionValue(value: any) {
    this.filterCrossQuestionValue?.setValue(value, {
      onlySelf: true,
    });
  }

  setFilterAnswerValue(value: any) {
    this.filterAnswerValue?.setValue(value, {
      onlySelf: true,
    });
  }
  setFilterRangeStart(value: any) {
    this.filterAnswerRangeStart?.setValue(value, {
      onlySelf: true,
    });
  }

  setFilterRangeEnd(value: any) {
    this.filterAnswerRangeEnd?.setValue(value, {
      onlySelf: true,
    });
  }

  get filterSelectedPeriodValue() {
    return this.filterOpenTextBoxesForm.get("filterSelectedPeriodValue");
  }
  get filterQuestionValue() {
    return this.filterOpenTextBoxesForm.get("filterQuestionValue");
  }
  get filterQuestionId() {
    return this.filterOpenTextBoxesForm.get("filterQuestionId");
  }
  get filterQuestionType() {
    return this.filterOpenTextBoxesForm.get("filterQuestionType");
  }
  get filterCrossQuestionValue() {
    return this.filterOpenTextBoxesForm.get("filterCrossQuestionValue");
  }
  get filterNPSValue() {
    return this.filterOpenTextBoxesForm.get("filterNPSValue");
  }
  get filterAggregationValue() {
    return this.filterOpenTextBoxesForm.get("filterAggregationValue");
  }

  get filterAnswerValue() {
    return this.filterOpenTextBoxesForm.get("filterAnswerValue");
  }
  get filterAnswerRangeStart() {
    return this.filterOpenTextBoxesForm.get("filterAnswerRangeStart");
  }

  get filterAnswerRangeEnd() {
    return this.filterOpenTextBoxesForm.get("filterAnswerRangeEnd");
  }

  get selectedFiltersListForm() : FormArray {
    return this.filterOpenTextBoxesForm.get("selectedFiltersListForm") as FormArray
  }

  setAnswerOption(idAnswer: string) {
    this.filterOpenTextBoxesForm.controls['filterAnswerValue'].setValue(idAnswer);
  }

  // On Component Initialized
  ngOnInit(): void {
    this.surveyState$.subscribe(surveyS => {
      this.periodList = surveyS.periodList;
      this.periodList?.forEach((period, index) => {
        if( period.id == 0) {
          this.periodOneStartDate = new Date(period.startDate);
          this.periodOneEndDate = new Date(period.endDate);
        }
        if( period.id == 1) {
          this.periodTwoStartDate = new Date(period.startDate);
          this.periodTwoEndDate = new Date(period.endDate);
        }
      });
      if (this.periodOneStartDate.toISOString() === this.periodTwoStartDate.toISOString() && this.periodOneEndDate.toISOString() === this.periodTwoEndDate.toISOString()) {
        this.isOnePeriod = true;
      }
      const nameSurvey = surveyS?.currentSurvey?.customName ? surveyS?.currentSurvey?.customName : surveyS?.currentSurvey?.name;
      this.surveyName = nameSurvey || "";
      this.currentSurvey = surveyS.currentSurvey
      this.filterQuestions = surveyS.filterQuestions;
      this.periodsCounters = surveyS.periodsCounters;
      this.filterAggregationValues = Object.keys(surveyS.touchpoints);
      this.touchpointsGroupped = this.formatTouchPoints(surveyS.touchpoints);
      this.questions = surveyS.questions;
      this.dashboardService.updateDataQuestions( this.questions );
      this.dashboardService.getTextAreaId({survey_id: this.currentSurvey.id}).subscribe(response => {
        this.textAreaQuestions = response.text_area_question_id;
        this.aiSelectedQuestion.patchValue(this.textAreaQuestions[0]);
      })
    });

    this.loadChartsData();
  }

  onChangeSelectQuestion() {
    if(this.filterQuestionValue?.value) {
      const selectedIndexQuestionId = parseInt(this.filterQuestionValue?.value, 10);
      const tempSelectedQuestion = this.filterQuestions.find(((tQuestion : Question)  => tQuestion.id === selectedIndexQuestionId));
      this.answersOptions = tempSelectedQuestion.answers;
      this.filteredQuestionType = tempSelectedQuestion.type;
      this.filterQuestionType?.patchValue(tempSelectedQuestion.type);
    }

    // this.setFilterAnswerValue("");
  }

  onClickAddNewFilter() {
    const filterQuestionValue = this.filterQuestionValue?.value;
    const filterQuestionType = this.filterQuestionType?.value;
    const filterAnswerValue = this.filterAnswerValue?.value;
    const filterAnswerRangeStart = this.filterAnswerRangeStart?.value;
    const filterAnswerRangeEnd = this.filterAnswerRangeEnd?.value;

    if(filterQuestionValue && filterAnswerValue) {
      this.addSelectedFilterList({filterQuestionValue, filterQuestionType, filterAnswerValue});
    } else if (filterQuestionValue && filterAnswerRangeStart !== null && filterAnswerRangeEnd !== null) {
      this.addSelectedFilterList({filterQuestionValue, filterQuestionType, filterAnswerRangeStart, filterAnswerRangeEnd});
    }

    this.filterQuestionValue?.patchValue('');
    this.filterQuestionType?.patchValue('');
    this.filterAnswerValue?.patchValue('');
    this.filterAnswerRangeStart?.patchValue('');
    this.filterAnswerRangeEnd?.patchValue('');
    this.filterQuestionValue?.markAsPristine();
    this.filterQuestionValue?.markAsUntouched();
    this.filterQuestionType?.markAsPristine();
    this.filterQuestionType?.markAsUntouched();
    this.filterAnswerValue?.markAsPristine();
    this.filterAnswerValue?.markAsUntouched();
    this.filterAnswerRangeStart?.markAsPristine();
    this.filterAnswerRangeStart?.markAsUntouched();
    this.filterAnswerRangeEnd?.markAsPristine();
    this.filterAnswerRangeEnd?.markAsUntouched();

    this.showOptionsContainer = false;
    this.showFiltersListFormVisible = false;
    this.loadChartsData();
  }

  onChangeAddNewFilter() {
    this.loadChartsData();
  }

  onChangeSelectCrossQuestion() {
    if(this.filterCrossQuestionValue?.value) {
      const crossQuestionId = parseInt(this.filterCrossQuestionValue?.value, 10 );
      this.selectedCrossQuestion = this.filterQuestions.find(((tQuestion : Question)  => tQuestion.id == crossQuestionId));

      this.loadChartsData();
    }
  }

  onClickCloseOptionsContainer() {
    this.showOptionsContainer = false;

    this.filterQuestionValue?.patchValue('');
    this.filterQuestionType?.patchValue('');
    this.filterAnswerValue?.patchValue('');
    this.filterAnswerRangeStart?.patchValue('');
    this.filterAnswerRangeEnd?.patchValue('');
    this.filterQuestionValue?.markAsPristine();
    this.filterQuestionValue?.markAsUntouched();
    this.filterQuestionType?.markAsPristine();
    this.filterQuestionType?.markAsUntouched();
    this.filterAnswerValue?.markAsPristine();
    this.filterAnswerValue?.markAsUntouched();
    this.filterAnswerRangeStart?.markAsPristine();
    this.filterAnswerRangeStart?.markAsUntouched();
    this.filterAnswerRangeEnd?.markAsPristine();
    this.filterAnswerRangeEnd?.markAsUntouched();


    this.filterQuestionId?.patchValue(null);
    this.filterQuestionId?.markAsPristine();
    this.filterQuestionId?.markAsUntouched();



  }

  onClickShowFiltersListForm () {
    this.showFiltersListFormVisible = true;
  }

  onClickRemoveLastFilter() {
    if(this.selectedFiltersListForm.value.length == 1) {
      this.showFiltersListFormVisible = true;
    }
    const lastIndex = (this.selectedFiltersListForm.value.length) -1;
    this.selectedFiltersListForm.removeAt(lastIndex);

    if (lastIndex > 0) {
      this.filterQuestionValue?.patchValue(this.selectedFiltersListForm.at(lastIndex - 1).value.filterQuestionId);
      this.filterQuestionType?.patchValue(this.selectedFiltersListForm.at(lastIndex - 1).value.filterQuestionType);
      this.filterAnswerValue?.patchValue(this.selectedFiltersListForm.at(lastIndex - 1).value.filterAnswerId);
      this.filterAnswerRangeStart?.patchValue(this.selectedFiltersListForm.at(lastIndex - 1).value.filterAnswerId);
      this.filterAnswerRangeEnd?.patchValue(this.selectedFiltersListForm.at(lastIndex - 1).value.filterAnswerId);
    } else {
      this.filterQuestionValue?.patchValue('');
      this.filterQuestionType?.patchValue('');
      this.filterAnswerValue?.patchValue('');
      this.filterAnswerRangeStart?.patchValue('');
      this.filterAnswerRangeEnd?.patchValue('');
      this.filterQuestionValue?.markAsPristine();
      this.filterQuestionValue?.markAsUntouched();
      this.filterQuestionType?.markAsPristine();
      this.filterQuestionType?.markAsUntouched();
      this.filterAnswerValue?.markAsPristine();
      this.filterAnswerValue?.markAsUntouched();
      this.filterAnswerRangeStart?.markAsPristine();
      this.filterAnswerRangeStart?.markAsUntouched();
      this.filterAnswerRangeEnd?.markAsPristine();
      this.filterAnswerRangeEnd?.markAsUntouched();

      this.filterQuestionId?.patchValue(null);
      this.filterQuestionId?.markAsPristine();
      this.filterQuestionId?.markAsUntouched();
    }

    this.loadChartsData();
  }

  addSelectedFilterList(filter: any) {
    this.selectedFiltersListForm.push(this.newFilter(filter));
  }

  newFilter(filter: any): FormGroup {
    return this.fb.group({
      filterQuestionId:  filter.filterQuestionValue,
      filterQuestionType:  filter.filterQuestionType,
      filterAnswerId: filter.filterAnswerValue,
      filterAnswerRangeStart: filter.filterAnswerRangeStart,
      filterAnswerRangeEnd: filter.filterAnswerRangeEnd,
    })
  }

  getLabelQuestionById(filterQuestionId: any) {
    if(filterQuestionId) {
      const tempSelectedQuestion = this.filterQuestions.find(((tQuestion : Question)  => tQuestion.id == filterQuestionId));
      if( tempSelectedQuestion) {
        return tempSelectedQuestion.description
      }
    }

    return " "
  }

  getLabelAnswerById(filterQuestionId: any, filterAnswerId: any, allowEmpty: boolean = false) {
    if(filterQuestionId && filterAnswerId) {
      const tempSelectedQuestion = this.filterQuestions.find(((tQuestion : Question)  => tQuestion.id == filterQuestionId));
      if( tempSelectedQuestion) {
        const answersTemp = tempSelectedQuestion.answers;
        const tempSelectedAnswer = answersTemp.find(((tAnswer : Answer)  => tAnswer.id == filterAnswerId));
        if( tempSelectedAnswer) {
          return tempSelectedAnswer.description
        }
      }
    }

    if (allowEmpty) {
      return "";
    }

    return "Select answer"
  }
  onClickDownloadImage() {
    const node = document.getElementById('dash-text-boxes-wrapper') as HTMLElement;
    const exportBtns = document.getElementsByClassName('export-wrapper');
    for (let index = 0; index < exportBtns.length; index ++) {
      (exportBtns[index] as HTMLElement).style.display = 'none';
    }
    this.loaderService.setLoading(true);
    htmlToImage.toPng(node)
      .then((dataUrl) => {
        const link = document.createElement('a');
        link.download = 'dash-text-boxes-chart-image.png';
        link.href = dataUrl;
        link.click();
        for (let index = 0; index < exportBtns.length; index ++) {
          (exportBtns[index] as HTMLElement).style.display = 'flex';
        }
        this.loaderService.setLoading(false);
      })
      .catch((error) => {
        console.error('oops, something went wrong!', error);
        for (let index = 0; index < exportBtns.length; index ++) {
          (exportBtns[index] as HTMLElement).style.display = 'flex';
        }
      });
  }

  getDomandaIdQuestionById(filterQuestionId: any) {
    if(filterQuestionId) {
      const tempSelectedQuestion = this.filterQuestions.find(((tQuestion : Question)  => tQuestion.id == filterQuestionId));
      if( tempSelectedQuestion) {
        return tempSelectedQuestion.domanda_id
      }
    }

    return " "
  }

  getImageAnswerById(filterQuestionId: any, filterAnswerId: any) {
    if(filterQuestionId && filterAnswerId) {
      const tempSelectedQuestion = this.filterQuestions.find(((tQuestion : Question)  => tQuestion.id == filterQuestionId));
      if( tempSelectedQuestion) {
        const answersTemp = tempSelectedQuestion.answers;
        const tempSelectedAnswer = answersTemp.find(((tAnswer : Answer)  => tAnswer.id == filterAnswerId));
        if( tempSelectedAnswer) {
          return tempSelectedAnswer.urlImage
        }
      }
    }

    return null
  }

  getFormatedCrossQuestion (crossQuestionId: any) {
    const crossQuestion = {
      question_id: crossQuestionId,
      domanda_id: this.getDomandaIdQuestionById(crossQuestionId),
    }

    return crossQuestion;
  }

  getFormatedFilters () {
    const formattedFilters: any = [];

    this.selectedFiltersListForm.controls.forEach( (filterElement) =>{
      const domandaId = this.getDomandaIdQuestionById(filterElement.value.filterQuestionId);
      const imagePath = this.getImageAnswerById(filterElement.value.filterQuestionId, filterElement.value.filterAnswerId);
      const description = this.getLabelAnswerById(filterElement.value.filterQuestionId, filterElement.value.filterAnswerId, true);
      const interval_start = filterElement.value.filterAnswerRangeStart;
      const interval_end = filterElement.value.filterAnswerRangeEnd;
      const question_type = filterElement.value.filterQuestionType;
      if (filterElement.value.filterQuestionId !== null) {
        formattedFilters.push({question_id: filterElement.value.filterQuestionId, domanda_id: domandaId, answer_image: imagePath, description: description, interval_start: interval_start, interval_end: interval_end, question_type: question_type })
      }
    });

    return formattedFilters;
  }

  getFormatedNpsRange () {
    const value = this.filterNPSValue?.value;
    switch (value) {
      case 'detractors':
        return [1,6];
      case 'passives':
        return [7,8];
      case 'promoters':
        return [9,10];
      default:
        return []
    }
  }

  getValueOfFilterAnswer(answers_filter: any, question_id: number) {
    const filterQuestion = this.filterQuestions.find((obj: any) => obj.id === question_id);
    const answerValue = answers_filter.find((obj: any) => obj.domanda_id === filterQuestion.domanda_id);

    return answerValue.risposta;
  }

  showMoreItems()
  {
    this.paginationLimit = Number(this.paginationLimit) + 10;
    this.loadChartsData();
  }
  showLessItems()
  {
    this.paginationLimit = Number(this.paginationLimit) - 10;
  }

  onChangeSelectPeriod () {
    const selectedPeriod = this.filterSelectedPeriodValue?.value as string;
    this.currentPeriodToggle = parseInt(selectedPeriod,10);
    this.paginationLimit = 10;
    this.loadChartsData();
  }

  onChangeSelectAggregationFilter() {
    this.loadChartsData();
    }
  onChangeSelectNPSFilter() {
    this.loadChartsData();

    // const selectedValue = this.form.get('filterNPSValue').value;

    // if (selectedValue === null) {
    //   // L'utente ha selezionato "None", azzera il filtro
    //   this.resetNPSFilter();
    // } else {
    //   // Applica il filtro normalmente
    //   this.applyNPSFilter(selectedValue);
    // }
  }

  loadChartsData() {
    this.showAiRecap = false;

    const periodOne = {
      startDate: this.periodOneStartDate.toISOString().split("T")[0],
      endDate: this.periodOneEndDate.toISOString().split("T")[0],
    }

    const periodTwo = {
      startDate: this.periodTwoStartDate.toISOString().split("T")[0],
      endDate: this.periodTwoEndDate.toISOString().split("T")[0],
    }

    const request: OpenTextBoxesRequest = {
      survey_id: this.currentSurvey?.id,
      survey_name: this.currentSurvey?.name,
      period:  this.currentPeriodToggle == 0? periodOne : periodTwo,
      filterQuestions: this.getFormatedFilters() || [],
      filterQuestionId: this.filterQuestionId?.value ? [this.filterQuestionId?.value] : [],
      filterTouchpoint: this.filterAggregationValue?.value || '',
      filterNps: this.getFormatedNpsRange() || [],
      offset: 0,
      limit: this.paginationLimit as number,
      emotion: this.filteredEmotion.value,
      confidence: {
        min: this.filteredConfidence.controls.min.value,
        max: this.filteredConfidence.controls.max.value,
      }
    }
    this.dashboardService.getOpenTextBoxesCharts(request).subscribe((data) =>
    {
      this.openTextBoxesAnswers$ = this.formatter.formatResponseOpenTextBoxes(data);

      this.cloudData = this.formatter.formatWordCloud(data.word_cloud);

      // this.aiRecaps = this.formatter.formatAiRecaps(data.ai_recaps);
      // this.aiThematics = this.formatter.formatAiThematics(data.ai_thematics);

      this.emotionsSummary = this.formatter.formatEmotionsCount(data.count_emotions);
      this.emotionsTotalCount = data.count_emotions_total;

      const emotionsForChart1 = [];
      const emotionsForChart2 = [];
      const emotionsForChart3 = [];
      for (let index = 0; index < this.emotionsSummary.length; index++) {
        if (this.emotionsSummary[index].emotion === 'N/A' || this.emotionsSummary[index].emotion === 'Indefinibile' || this.emotionsSummary[index].emotion === 'Non risposta') {
          this.emotionsTotalCount -= this.emotionsSummary[index].count;
        } else {
          const _key = this.emotionsSummary[index].emotion.toLowerCase().replaceAll(' ', '_');
          const color = this.emotionColors[this.emotionsSummary[index].emotion.toLowerCase()] ?? "#787A75";
          emotionsForChart1.push({
            value: this.emotionsSummary[index].count,
            name: this.emotionsMapping[_key] ? this.emotionsMapping[_key] : this.emotionsSummary[index].emotion,
            itemStyle: {color: this.getShadeColor(color, 10, 0.7)},
          });
          emotionsForChart2.push({
            value: this.emotionsSummary[index].count,
            name: this.emotionsMapping[_key] ? this.emotionsMapping[_key] : this.emotionsSummary[index].emotion,
            itemStyle: {color: color},
          });
          emotionsForChart3.push({
            value: this.emotionsSummary[index].count,
            name: this.emotionsMapping[_key] ? this.emotionsMapping[_key] : this.emotionsSummary[index].emotion,
            itemStyle: {color: this.getShadeColor(color, -20, 1)},
          });
        }
      }

      this.chartEmotionsOption = {
        backgroundColor: '#ffffff',
        height: '300px',
        tooltip: {
          trigger: 'item',
          formatter: '{b} ({d}%)',
        },
        visualMap: {
          show: false,
          min: 0,
          max: 300,
          inRange: {
            colorLightness: [0, 1],
          },
        },
        series: [
          {
            type: 'pie',
            center: ['50%', '50%'],
            radius: '90%',
            emphasis: {
              disabled: true,
            },
            data: emotionsForChart1,
            label: {
              show: true,
              // eslint-disable-next-line func-names
              formatter: function(params) {
                const percentage = params.percent?.toFixed(2);
                const name = params.name;

                return `${name} (${percentage}%)`;
              }
            },
          },
          {
            type: 'pie',
            center: ['50%', '50%'],
            radius: '50%',
            emphasis: {
              disabled: true,
            },
            data: emotionsForChart2,
            label: {
              show: false,
            },
          },
          {
            type: 'pie',
            center: ['50%', '50%'],
            radius: '20%',
            emphasis: {
              disabled: true,
            },
            data: emotionsForChart3,
            label: {
              show: false,
            },
          },
        ]
      };
    });

  }

  formatTouchPoints (data: any) {
    const touchpointsData: any[] = [];
    for (const key in data) {
      const questionsTemp = data[key];
      const questions = []
      for (let index = 0; index < questionsTemp.length; index++) {
          questions.push({
            domanda_id: questionsTemp[index].domanda_id,
            question_id: questionsTemp[index].question_id,
            description: questionsTemp[index].description,
          });
      }
      touchpointsData.push({
        group: key,
        questions: questions,
        rowspan: questions.length,
      })
    }

    return touchpointsData;
  }

  toggleModalKeys( ) {
    this.showModalKeys = !this.showModalKeys;
    this.dashboardService.updateVisibilityQuestions(this.showModalKeys);
  }

  getQuestionFromId(domanda_id: number | string) {
    const _domanda_id = typeof domanda_id === 'string' ? parseInt(domanda_id) : domanda_id;
    const questionById = this.questions.filter((question: any) => question.domanda_id === _domanda_id);

    return questionById.length ? questionById[0].description : "";
  }

  toggleAccordionCloud() {
    this.showAccordionCloud = !this.showAccordionCloud;
    if (this.showAccordionCloud) {
      this.showAccordionFindings = false;
    }
  }

  validNewFilter(type: string, range_start: number, range_end: number) {
    if (type === 'knob' || type === 'slider') {
      return this.filterAnswerRangeStart?.valid &&
        this.filterAnswerRangeEnd?.valid &&
        this.filterAnswerRangeStart?.value !== null &&
        this.filterAnswerRangeEnd?.value !== null &&
        parseInt(this.filterAnswerRangeStart?.value) < parseInt(this.filterAnswerRangeEnd?.value) &&
        parseInt(this.filterAnswerRangeStart?.value) >= range_start &&
        parseInt(this.filterAnswerRangeStart?.value) <= range_end &&
        parseInt(this.filterAnswerRangeEnd?.value) >= range_start &&
        parseInt(this.filterAnswerRangeEnd?.value) <= range_end;
    } else {
      return this.filterAnswerValue?.valid;
    }
  }

  isNumeric(answer: any) {
    if (answer === '' || answer === null) {
      return false
    }

    return !isNaN(answer)
  }

  // AI
  setShowEmotionsSummary(value: boolean) {
    this.showEmotionsSummary = value;
  }

  setShowRefreshAiModal(value: boolean) {
    this.showRefreshAiModal = value;
  }

  toggleAiRecap() {
    this.showAiRecap = !this.showAiRecap;
    this.showAccordionCloud = false;
    this.showAccordionFindings = false;
    this.aiReload();
  }

  toggleAccordionFindings() {
    this.showAccordionFindings = !this.showAccordionFindings;
    if (this.showAccordionFindings) {
      this.showAccordionCloud = false;
    }
  }

  getAiRecapFromQuestion() {
    if (this.aiSelectedQuestion.value) {
      return this.aiRecaps[this.aiSelectedQuestion.value];
    }

    return null;
  }

  getAiThematicsFromQuestion() {
    if (this.aiSelectedQuestion.value) {
      return this.aiThematics[this.aiSelectedQuestion.value];
    }

    return null;
  }

  aiReload() {
    this.hasReloadedAi = true;

    const periodOne = {
      startDate: this.periodOneStartDate.toISOString().split("T")[0],
      endDate: this.periodOneEndDate.toISOString().split("T")[0],
    }

    const periodTwo = {
      startDate: this.periodTwoStartDate.toISOString().split("T")[0],
      endDate: this.periodTwoEndDate.toISOString().split("T")[0],
    }

    const request: FilteredAiRequest = {
      survey_id: this.currentSurvey?.id,
      survey_name: this.currentSurvey?.name,
      period:  this.currentPeriodToggle == 0 ? periodOne : periodTwo,
      filterQuestions: this.getFormatedFilters() || [],
      filterQuestionId: this.filterQuestionId?.value ? [this.filterQuestionId?.value] : [],
      filterTouchpoint: this.filterAggregationValue?.value || '',
      filterNps: this.getFormatedNpsRange() || [],
    };

    this.dashboardService.filteredRecap(request).subscribe((data) => {
      if (data.responseAI.length) {
        this.aiRecaps = this.formatter.formatAiRecapsFiltered(data.responseAI);
      } else {
        this.toastr.error("Errore AI: clicca ancora il bottone di refresh");
      }
    });

    this.dashboardService.filteredKeyFindings(request).subscribe((data) => {
      if (data.responseAI.length) {
        this.aiThematics = this.formatter.formatAiThematicsFiltered(data.responseAI);
      } else {
        this.toastr.error("Errore AI: clicca ancora il bottone di refresh");
      }
    });
  }

  showEditEmotionForm(event_id: number, emotion: string) {
    this.editQuestionEmotion.patchValue({
      event_id: event_id,
      emotion: emotion,
    });
  }
  closeEditEmotionForm() {
    this.editQuestionEmotion.patchValue({
      event_id: 0,
      emotion: "",
    });
  }
  onSubmitEditEmotion() {
    const request: AnswerEmotionRequest = {
      event_id: this.editQuestionEmotion.controls.event_id.value!,
      survey_id: this.currentSurvey.id,
      emotion: this.editQuestionEmotion.controls.emotion.value!,
    };
    this.dashboardService.commentEmotionUpdate(request).subscribe((data) => {
      if (data.status === "ok") {
        const questionById = this.openTextBoxesAnswers$.filter((answer: any) => answer.event_id === this.editQuestionEmotion.controls.event_id.value);
        if (questionById) {
          questionById[0].emotion = this.editQuestionEmotion.controls.emotion.value;
          questionById[0].sicurezza = 100;
        }
      } else {
        this.toastr.error("Errore durante il salvataggio dell'emozione");
      }
      this.closeEditEmotionForm();
    });
  }

  setShowFilterEmotions(value: boolean) {
    this.showFilterEmotions = value;
  }
  setShowFilterConfidence(value: boolean) {
    this.showFilterConfidence = value;
  }
  submitFilterByEmotion() {
    this.loadChartsData();
    this.setShowFilterEmotions(false);
  }
  resetFilteredEmotion() {
    this.filteredEmotion.patchValue('');
    this.loadChartsData();
    this.setShowFilterEmotions(false);
  }
  submitFilterByConfidence() {
    this.loadChartsData();
    this.setShowFilterConfidence(false);
  }
  resetFilteredConfidence() {
    this.filteredConfidence.patchValue({
      min: 0,
      max: 100,
    });
    this.loadChartsData();
    this.setShowFilterConfidence(false);
  }

  onClickDownloadEmotions() {
    const node = document.getElementById('export-emotions') as HTMLElement;
    this.loaderService.setLoading(true);
    htmlToImage.toPng(node)
      .then((dataUrl) => {
        const link = document.createElement('a');
        link.download = 'dash-text-boxes-emotions.png';
        link.href = dataUrl;
        link.click();
        this.loaderService.setLoading(false);
      })
      .catch((error) => {
        console.error('oops, something went wrong!', error);
      });
  }

  onClickExportAiSummary() {
    const rows = [
      ["Question " + this.aiSelectedQuestion.value, this.getQuestionFromId(parseInt(this.aiSelectedQuestion.value!)), "Examples", "Frequency", "Action Recommendation"],
      ["", "", "", "", ""],
      ["Riassunto", this.getAiRecapFromQuestion().riassunto, "", "", ""],
      ["", "", "", "", ""],
    ];
    const thematics = this.getAiThematicsFromQuestion();
    for (let index = 0; index < thematics.length; index++) {
      const _theme = thematics[index].tema_principale.replaceAll('_', ' ');
      rows.push([
        _theme.charAt(0).toUpperCase() + _theme.slice(1),
        thematics[index].riassunto.replaceAll('\n', ' '),
        thematics[index].esempi.join(' --- '),
        thematics[index].frequenza,
        this.toneMapping[thematics[index].tono]
      ]);
    }

    const csvContent = "data:text/csv;charset=utf-8,"
        + rows.map(_e => _e.join(";")).join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `ai-summary-question-${this.aiSelectedQuestion.value}.csv`);
    document.body.appendChild(link);

    link.click();
  }

  getShadeColor(color: string, percent: number, alpha: number) {
    let _R = parseInt(color.substring(1, 3), 16);
    let _G = parseInt(color.substring(3, 5), 16);
    let _B = parseInt(color.substring(5, 7), 16);

    _R = _R * (100 + percent) / 100;
    _G = _G * (100 + percent) / 100;
    _B = _B * (100 + percent) / 100;

    _R = (_R < 255) ? _R : 255;
    _G = (_G < 255) ? _G : 255;
    _B = (_B < 255) ? _B : 255;

    _R = Math.round(_R);
    _G = Math.round(_G);
    _B = Math.round(_B);

    const RR = ((_R.toString(16).length == 1) ? "0" + _R.toString(16) : _R.toString(16));
    const GG = ((_G.toString(16).length == 1) ? "0" + _G.toString(16) : _G.toString(16));
    const BB = ((_B.toString(16).length == 1) ? "0" + _B.toString(16) : _B.toString(16));

    const _A = Math.round(255 * alpha);
    const AA = ((_A.toString(16).length == 1) ? "0" + _A.toString(16) : _A.toString(16));

    return "#" + RR + GG + BB + AA;
  }

  getCurrentPeriod() {
    return this.currentPeriodToggle == 0 ? {
      startDate: this.periodOneStartDate,
      endDate: this.periodOneEndDate,
    } : {
      startDate: this.periodTwoStartDate,
      endDate: this.periodTwoEndDate,
    };
  }
}
